import React, { Component } from 'react';
import { Modal, Spin, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

const CONSTANTS = {
    title: '版本对比',
};

class CompareVersion extends Component {
    state = {
        data: [],
        checkedValues: [],
        visible: false,
        loading: false,
    }

    loadData = () => {
        // const { record: { jdeMainApplyId } } = this.state;
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.queryJdeMainApplyApprovalHistory, {
        //     jdeMainApplyId,
        // }).then(res => {
        //     this.setState({
        //         data: res.data,
        //         loading: false,
        //     }, () => {
        //         this.loadData();
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({ data: [
            {compareField: '随机例数', V1: 10, V2: 12, V3: 12},
            {compareField: '每例病人访视次数', V1: 2, V2: 3, V3: 2},
            {compareField: '中心数', V1: 1, V2: 1, V3: 1},
            {compareField: '是否需要中心阅片', V1: '是', V2: '是', V3: '否'},
        ] });
    }

    show = (checkedValues) => {
        this.setState({
            checkedValues,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => {
        const { checkedValues } = this.state;
        const columns = [{
            title: '对比版本及对比数据',
            dataIndex: 'compareField',
            key: 'compareField',
            width: 160,
        }];
        (checkedValues || []).forEach(value => {
            columns.push({
                title: value,
                dataIndex: value,
                key: value,
                width: 100,
                render: (text, record) => {
                    const index = checkedValues.indexOf(value);
                    let setting = {};
                    if (index > 0 && record[checkedValues[index - 1]] !== text) {
                        setting = {
                            color: '#FFF',
                            background: '#3399FF',
                        };
                    }
                    return (
                        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', padding: '10px 8px', ...setting }}>{text}</div>
                    );
                }
            });
        });
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    render() {
        const { visible, loading } = this.state;
        // const { quotationNum, salesforceId } = record;
        return (
            <Modal
                title={CONSTANTS.title}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="800px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div style={{ marginBottom: 16 }}>
                        报价单号：202009151652
                        <span className="ant-divider" />
                        Salesforce ID：ASK202009151652
                        <span className="ant-divider" />
                        最新版本：V5
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <p>
                            领域：肿瘤
                            <span className="ant-divider" />
                            适应症：非小细胞肺癌
                            <span className="ant-divider" />
                            分期：II期
                        </p>
                        <p>
                            筛选失败率：25.66%
                            <span className="ant-divider" />
                            SAE发生率：2.22%
                        </p>
                    </div>
                    <TableC
                        loading={loading}
                        data={this.getDataSource()}
                        columns={this.getColumns()}
                        className="compareVersion"
                    />
                </div>
            </Modal>
        );
    }
}

export default CompareVersion;


// WEBPACK FOOTER //
// ./src/components/quotation/Sidebar/Components/CompareVersion.js